export const accent = {
  DEFAULT: '#535CDC',
  50: '#EFF5FE',
  100: '#E2EBFD',
  200: '#CADAFB',
  300: '#AAC0F7',
  400: '#889FF1',
  500: '#6C7DE8',
  600: '#535CDC',
  700: '#4147C1',
  800: '#373D9C',
  900: '#33397C',
  950: '#1E2048',
};

export const neutral = {
  50: '#F3F5FB',
  100: '#E3EAF6',
  200: '#CDDBF0',
  300: '#ABC2E5',
  400: '#83A3D7',
  500: '#6585CC',
  600: '#526DBE',
  700: '#475BAE',
  800: '#3F4C8E',
  900: '#364272',
  950: '#222741',
};

export const lavander = {
  50: '#EEF2FF',
  100: '#DFE6FF',
  200: '#C5CFFF',
  300: '#A3B0FE',
  400: '#7F87FA',
  500: '#6060F4',
  600: '#5143E8',
  700: '#4535CD',
  800: '#382EA5',
  900: '#322C83',
  950: '#1E1A4C',
};

export const gray = {
  DEFAULT: '#8D8F9F',
  50: '#F5F5F5',
  100: '#EFEFEF',
  200: '#DCDCDC',
  300: '#BDBDBD',
  400: '#989898',
  500: '#7C7C7C',
  600: '#656565',
  700: '#525252',
  800: '#464646',
  900: '#3D3D3D',
  950: '#292929',
};

export const green = {
  50: '#EFFAF4',
  100: '#D8F3E2',
  200: '#B5E5C9',
  300: '#84D1A8',
  400: '#51B684',
  500: '#2F9A69',
  600: '#218358',
  700: '#196344',
  800: '#164F38',
  900: '#13412F',
  950: '#0A241B',
};

export const yellow = {
  50: '#FFF9EB',
  100: '#FEEABF',
  200: '#FDD88A',
  300: '#FCBE4D',
  400: '#FBA624',
  500: '#F6820A',
  600: '#D95E06',
  700: '#B43F09',
  800: '#92300E',
  900: '#78290F',
  950: '#451203',
};

export const orange = {
  50: '#FDF4EE',
  100: '#FAE5D8',
  200: '#F5C6AF',
  300: '#EC916B',
  400: '#E7704C',
  500: '#E35030',
  600: '#D43C26',
  700: '#B02D1F',
  800: '#8C241D',
  900: '#70201A',
  950: '#3C0D0B',
};

export const red = {
  50: '#FDF3F3',
  100: '#FDE3E4',
  200: '#FBCDCE',
  300: '#F8A9AB',
  400: '#F1787C',
  500: '#E64D52',
  600: '#CE2C31',
  700: '#B12428',
  800: '#932125',
  900: '#7A2225',
  950: '#420D0F',
};

export const purple = {
  600: '#6060F4',
  700: '#895EFF',
  900: '#4117B2',
};

export const text = {
  black: '#0A121A',
  'dark-gray': '#5C6068',
  gray: '#8D8F9F',
  'light-gray': '#D0D1DA',
  'accent-high-contrast': '#222741',
  white: '#FFFFFF',
};

export const background = {
  accent: '#535CDC',
  'accent-high-contrast': '#222741',
  black: '#1A2022',
  gray: '#F5F5F5',
  'gray-2': '#E1E2E9',
  'light-gray': '#FAFAFA',
  white: '#FFFFFF',
  'accent-orange': '#E7704C',
  'light-gray-2': '#D0D1DA',
  'dark-gray': '#5C6068',
};

export const border = {
  gray: '#E1E2E9',
  'light-gray': '#EDEEF4',
  lg: '#FAFAFA',
  accent: '#535CDC',
  black: '#1A2022',
  'light-blue': '#EFF5FE',
};

export const fill = {
  accent: '#535CDC',
  'accent-high-contrast': '#222741',
  black: '#1A2022',
  gray: '#F5F5F5',
  'light-gray': '#FAFAFA',
  white: '#FFFFFF',
};
